import VideoBase from "./VideoBase";

/** Get ID of a vimeo video from URL
* @param {string} url
* @return {string} vimeo video ID
*/
function vimeoGetId(url) {
  const regex = /(videos|video|channels|\.com)\/([\d]+)/;
  const parts = url.match(regex);
  const partsNum = url.split('/');

  // Handle URLs like https://vimeo.com/413064250/6b8fd8d053
  if(partsNum.length > 4) {
    return url;
  }
  else if (parts && parts[2] !== undefined) {
    return parts[2];
  }

  return url;
}

export default class Vimeo extends VideoBase {
  _load = () => {
    return this.theme.loadVimeoApi();
  }

  init = ({ autoplay, hideControls, url, mute, loop, onPlay, onEnd }) => {
    autoplay = this.getAutoplay(autoplay);
    const videoId = vimeoGetId(url);

    return new Promise((resolve, reject) => {
      this._load().then(
        (Vimeo) => {
          this.player = new Vimeo.Player(this.element, {
            id: videoId,
            autoplay: autoplay,
            controls: !hideControls,
            byline: false,
            portrait: false,
            title: false
          });

          this.player.ready().then(() => {
            if (mute || autoplay) {
              this.player.setVolume(0);
            }
            if (loop) {
              this.player.setLoop(true);
            }
            if (autoplay) {
              this.player.play();
            }
            resolve(this.player);
          });
          this.player.on('play', () => {
            onPlay();
          });
          this.player.on('ended', () => {
            onEnd();
          });
        },
      );
    });
  }

  play = () => {
    this.player.play();
  }
}
